import { useNavigate } from "react-router-dom";
export default function NotFound() {

    const navigate = useNavigate();
    return (
        <div className="d-flex flex-column flex-center flex-column-fluid">
            <div className="d-flex flex-column flex-center text-center p-10">
                <div className="card card-flush w-lg-650px py-5">
                    <div className="card-body py-15 py-lg-20">
                        <i className="ki-duotone ki-shield-cross fs-7tx text-primary">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                        </i>
                        <h1 className="fw-bolder fs-2hx text-gray-900 mb-4">Oops!</h1>
                        <div className="fw-semibold fs-6 text-gray-500 mb-7">No se encontro la pagina.</div>
                        <div className="mb-0">
                            <button className="btn btn-sm btn-primary" onClick={() => navigate('/contrato/clientes')}>Volver</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
